<div class="nested-preview-window" *ngIf="previewData">
  <button
    type="button"
    class="close-preview cursor"
    [class.hide-print-control]="isPrintClicked"
    (click)="closePreview()">
    <mat-icon>close</mat-icon>
  </button>

  <div
    *ngIf="previewData.isPreviewWarning"
    class="print-warning"
    [class.hide-print-control]="isPrintClicked">
    {{ warningMessage }}
  </div>

  <div class="preview-scroll">
    <div class="logo" title="PACTrak">
      <img src="assets/Logo.svg" alt="" />
    </div>

    <div class="print-page {{ previewData.selectedPageSize }}">
      <ng-container *ngFor="let record of previewData.records; trackBy: trackRecord">
        <ng-container *ngFor="let section of record.sections; trackBy: trackSection">
          <ng-container
            *ngTemplateOutlet="sectionTemplate; context: { section: section }">
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <button
    class="ibc-medium-button ibc-primary-default-button cursor preview-print-btn"
    [class.hide-print-control]="isPrintClicked"
    (click)="print()">
    <span class="ibc-body-text-regular">{{ popupButtons.Print }}</span>
  </button>
</div>

<ng-template #sectionTemplate let-section="section">
  <div class="preview-section" *ngIf="isSummarySection(section); else permissionSectionTemplate">
    <div class="section-title ibc-heading-h7-bold-subtitle">
      {{ section.label }}
    </div>

    <table class="ibc-print-table" *ngIf="section.columns?.length">
      <thead>
        <tr>
          <th
            *ngFor="let option of section.columns"
            class="print-column"
            [style.--print-col-width.px]="option.width || 150">
            <div class="ibc-body-text-large-bold table-text">
              {{ option.label }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            *ngFor="let option of section.columns"
            class="print-column"
            [style.--print-col-width.px]="option.width || 150">
            <span class="ibc-body-text-regular table-text">
              {{ permissionValue(option) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #permissionSectionTemplate>
    <div class="preview-section" *ngIf="section.type === 'group'">
      <div class="section-title ibc-heading-h7-bold-subtitle">
        {{ section.label }}
      </div>

      <ng-container *ngFor="let child of section.children">
        <div class="print-subtitle ibc-body-text-large-bold">{{ child.label }}</div>

        <table class="ibc-print-table" *ngIf="child.columns?.length">
          <ng-container *ngIf="isActionPermissions(child); else fieldTable">
            <thead>
              <tr>
                <th class="action-permission-column">
                  <div class="ibc-body-text-large-bold table-text">Action</div>
                </th>
                <th class="action-permission-column">
                  <div class="ibc-body-text-large-bold table-text">Permission</div>
                </th>
                <th class="action-permission-column">
                  <div class="ibc-body-text-large-bold table-text">Action</div>
                </th>
                <th class="action-permission-column">
                  <div class="ibc-body-text-large-bold table-text">Permission</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let pair of pairOptions(child.columns)">
                <ng-container *ngFor="let option of pair">
                  <td class="action-permission-column">
                    <span class="ibc-body-text-regular table-text">{{ option.label }}</span>
                  </td>
                  <td class="action-permission-column">
                    <span class="ibc-body-text-regular table-text">
                      {{ permissionValue(option) }}
                    </span>
                  </td>
                </ng-container>
                <ng-container *ngIf="pair.length === 1">
                  <td class="action-permission-column"></td>
                  <td class="action-permission-column"></td>
                </ng-container>
              </tr>
            </tbody>
          </ng-container>

          <ng-template #fieldTable>
            <thead>
              <tr>
                <th
                  *ngFor="let option of child.columns"
                  class="print-column"
                  [style.--print-col-width.px]="option.width || 150">
                  <div class="ibc-body-text-large-bold table-text">
                    {{ option.label }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  *ngFor="let option of child.columns"
                  class="print-column"
                  [style.--print-col-width.px]="option.width || 150">
                  <span class="ibc-body-text-regular table-text">
                    {{ permissionValue(option) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </ng-template>
        </table>

        <ng-container *ngIf="isActionPermissions(child)">
          <ng-container *ngFor="let pageSection of child.children">
            <div class="field-level-group-title ibc-body-text-regular">
              {{ pageSection.label }}
            </div>
            <table class="ibc-print-table" *ngIf="pageSection.columns?.length">
              <thead>
                <tr>
                  <th class="action-permission-column">
                    <div class="ibc-body-text-large-bold table-text">Action</div>
                  </th>
                  <th class="action-permission-column">
                    <div class="ibc-body-text-large-bold table-text">Permission</div>
                  </th>
                  <th class="action-permission-column">
                    <div class="ibc-body-text-large-bold table-text">Action</div>
                  </th>
                  <th class="action-permission-column">
                    <div class="ibc-body-text-large-bold table-text">Permission</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pair of pairOptions(pageSection.columns)">
                  <ng-container *ngFor="let option of pair">
                    <td class="action-permission-column">
                      <span class="ibc-body-text-regular table-text">{{ option.label }}</span>
                    </td>
                    <td class="action-permission-column">
                      <span class="ibc-body-text-regular table-text">
                        {{ permissionValue(option) }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="pair.length === 1">
                    <td class="action-permission-column"></td>
                    <td class="action-permission-column"></td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="isFieldLevelSection(child)">
          <div class="field-level-description ibc-body-text-regular" *ngIf="child.description">
            Field Level Permissions ({{ child.description }})
          </div>

          <ng-container *ngFor="let tabSection of child.children">
            <ng-container *ngIf="!tabSection.children?.length">
              <div
                class="field-level-group-title ibc-body-text-regular"
                *ngIf="shouldShowFieldLevelGroupTitle(tabSection)">
                {{ tabSection.label }}
              </div>
              <table class="ibc-print-table">
                <thead>
                  <tr>
                    <th
                      *ngFor="let option of tabSection.columns"
                      class="print-column"
                      [style.--print-col-width.px]="option.width || 150">
                      <div class="ibc-body-text-large-bold table-text">
                        {{ option.label }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      *ngFor="let option of tabSection.columns"
                      class="print-column"
                      [style.--print-col-width.px]="option.width || 150">
                      <span class="ibc-body-text-regular table-text">
                        {{ permissionValue(option) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>

            <ng-container *ngFor="let legendSection of tabSection.children">
              <div
                class="field-level-group-title ibc-body-text-regular"
                *ngIf="shouldShowFieldLevelGroupTitle(legendSection)">
                {{ legendSection.label }}
              </div>
              <table class="ibc-print-table" *ngIf="legendSection.columns?.length">
                <thead>
                  <tr>
                    <th
                      *ngFor="let option of legendSection.columns"
                      class="print-column"
                      [style.--print-col-width.px]="option.width || 150">
                      <div class="ibc-body-text-large-bold table-text">
                        {{ option.label }}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      *ngFor="let option of legendSection.columns"
                      class="print-column"
                      [style.--print-col-width.px]="option.width || 150">
                      <span class="ibc-body-text-regular table-text">
                        {{ permissionValue(option) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</ng-template>
